import { useEffect, useState } from "react";
import { History } from "lucide-react";
import { api } from "@/lib/api";

const WHAT = {
  created: "Login created",
  edited: "Edited",
  password_reset: "Password reset",
  password_changed: "Changed own password",
  password_email: "Password reset by email link",
};
const when = (iso) => new Date(iso).toLocaleString(undefined, { year: "numeric", month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });

export function LoginHistory({ uid, createdAt }) {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get(`/users/${uid}/history`).then((r) => setRows(r.data)).catch(() => setRows([])); }, [uid]);
  if (!rows) return null;
  return (
    <div className="space-y-2 rounded-lg border border-slate-200 bg-[hsl(var(--sand))] p-3" data-testid="login-history">
      <div className="flex items-center gap-2 text-sm font-semibold text-slate-800"><History className="h-4 w-4" /> Change history</div>
      {!rows.length && <p className="text-xs text-slate-500" data-testid="login-history-empty">No changes recorded yet{createdAt ? ` · login made ${when(createdAt)}` : ""}.</p>}
      <ul className="max-h-48 space-y-1.5 overflow-y-auto">
        {rows.map((h) => (
          <li key={h.id} className="rounded-md bg-white px-2.5 py-1.5 text-xs" data-testid={`login-history-${h.action}`}>
            <span className="font-semibold text-slate-900">{WHAT[h.action] || h.action}</span>
            {h.changes?.length > 0 && <span className="text-slate-600">: {h.changes.join(", ")}</span>}
            <span className="block text-slate-500">{h.by_name ? `by ${h.by_name} · ` : ""}{when(h.at)}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
